import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import Grid from '@material-ui/core/Grid';

export const Proxyfor = styled.div`
    color: #140f4b;
    font-size: 14px;
    font-family: AvenirNextWorld Regular;
    align-item: left;
    margin: 0 0 4px 0;
`;

export const Username = styled.div`
    font-family: AvenirNextWorld Demi;
    color: #140f4b;
    font-size: 16px;
    align-item: left;
    margin: 0 0 4px 0;
`;

export const Designation = styled.div`
    font-family: AvenirNextWorld Demi;
    color: #202124;
    font-size: 14px;
    align-item: left;
    margin: 0 0 4px 0;
    opacity: 0.7;
`;

export const Usercode = styled.div`
    display: flex;
    font-family: AvenirNextWorld Regular;
    font-size: 14px;
    letter-spacing: 0.42px;
`;
export const NameContainer = styled.div`
    color: #140f4b;
    font-size: 16px;
    font-family: AvenirNextWorld Demi;
`;
export const RoleContainer = styled.div`
    color: #202124;
    font-size: 14px;
    font-family: AvenirNextWorld Regular;
    opacity: 0.74;
`;
export const DistContainer = styled.div`
    color: #202124;
    font-size: 14px;
    font-family: AvenirNextWorld Demi;
`;
export const DistrictContainer = styled.div`
    color: #202124;
    font-size: 15px;
    font-family: AvenirNextWorld Regular;
`;
export const UserProxyListContainer = styled.div`
    display: ${(props) => (props.showDiv ? 'block' : 'none')};
    max-height: 260px;
    overflow: scroll;
    &::-webkit-scrollbar {
        display: ${({ theme }) => theme.scrollOption.show};
        width: 5px;
    }
    &::-webkit-scrollbar-track {
        margin-top: 0px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: ${({ theme }) => theme.scrollOption.thumb_color};
        border-radius: ${({ theme }) => theme.scrollOption.border_radius};
        height: 40px;
    }
    ${media.mobileDevice`
        padding: 10px 25px 5px 25px;
        max-height: unset;
        overflow: unset;
        &::-webkit-scrollbar {
            display: none;
        }
    `}
`;

export const Line = styled(Grid)`
    margin-right: 3%;
    margin-top: 15px;
    width: 100%;
    height: 1px;
    background-color: #707070;
    // border: 0.6px solid #707070;
    opacity: 0.3;
    ${media.smalDevice`
    margin-right: 2%;  
  `}
    ${media.mobileDevice`
    margin-left: 0%;
    margin-right: 0%;
    width: 100%;
    // margin-top: 0px;    
  `}
`;

export const ProxyListContainerWrapper = styled.div`
    border-bottom: 1px solid #d4d4d4;
    ${media.mobileDevice`
        :last-child {
            border-bottom: none;
        }
    `}
`;
